module.exports = __webpack_public_path__ + "static/img/light-blur.6b8a311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/light-blur.png
// module id = 664
// module chunks = 64